




















































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { ILocation } from '@/interfaces';
import { readLocations } from '@/store/locations/getters';
import { dispatchGetLocations } from '@/store/locations/actions';
import { apiUrl } from '@/env';

@Component
export default class Locations extends Vue {

  public headers = [
    {
      text: 'Id',
      sortable: true,
      value: 'id',
      align: 'left',
    },
    {
      text: 'Nombre',
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: 'Latitud',
      sortable: false,
      value: 'latitude',
      align: 'left',
    },
    {
      text: 'Longitud',
      sortable: false,
      value: 'longitude',
      align: 'left',
    },
    {
      text: 'Imagen',
      sortable: false,
      value: 'image',
      align: 'left',
    },
    {
      text: 'Actions',
      sortable: false,
      value: 'id',
    },
  ];

  get locations() {
    return readLocations(this.$store);
  }

  public imageUrl(mediaUrl: string): string {
    return `${apiUrl}${mediaUrl}`;
  }

  public async mounted() {
    // carga los datos de la api
    await dispatchGetLocations(this.$store);
  }
}
